// URLs.
export const FIREBASE_URL = 'https://firebasestorage.googleapis.com';
export const STORAGE_BUCKET_BASE_URL = `${FIREBASE_URL}/v0/b/${process.env.REACT_APP_STORAGE_BUCKET}`;

// Collections.
export const MESSAGES_COLLECTION = 'daily-messages';
export const PROGRAMS_COLLECTION = 'programs';
export const ADMINS_COLLECTION = 'admins';
